'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VehicleImagesController = function () {
  function VehicleImagesController(appConfig, enums, loadingService, vehicleService, $scope, $ngConfirm, brandingService, authService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, VehicleImagesController);
    this.appConfig = appConfig;
    this.enums = enums;
    this.loadingService = loadingService;
    this.vehicleService = vehicleService;
    this.$scope = $scope;
    this.$ngConfirm = $ngConfirm;
    this.brandingService = brandingService;
    this.authService = authService;

    this.uploadUrl = appConfig.apiServiceBaseUri + 'api/file/upload';
    this.mediaUrl = appConfig.apiServiceBaseUri + 'api/file/get';

    this.sortableConfig = {
      onEnd: this.dragEndHandler.bind(this)
    };

    this.$scope.$on('vehicle:initialized', this.vehicleInitialized.bind(this));

    this.video = null;

    this.initializeBrandingTemplates();
    this.brandingApplied = false;
    this.brandingSaved = false;
  }

  (0, _createClass3.default)(VehicleImagesController, [{
    key: 'vehicleInitialized',
    value: function vehicleInitialized() {
      var _this = this;

      this.video = (0, _lodash.find)(this.vehicle.mediaItems, function (mi) {
        return mi.mediaType === _this.enums.MEDIA_TYPE.Youtube;
      });
    }
  }, {
    key: 'showUploading',
    value: function showUploading() {
      this.formValidationService.resetValidations();
      this.loadingService.showLoading('mediaItems', 'Uploading Media Item(s)');
    }
  }, {
    key: 'hideUploading',
    value: function hideUploading(response) {
      this.loadingService.hideLoading('mediaItems');

      if (response) {
        this.formValidationService.addSystemError(null, "A system error occurred while processing your request. Please try again later or contact system administrator if problem persists.");
      }
    }
  }, {
    key: 'onMediaUploadSuccess',
    value: function onMediaUploadSuccess(response) {
      var _this2 = this;

      this.hideUploading();

      response.data.map(function (item) {
        _this2.vehicle.mediaItems.push({
          mediaType: item.key,
          url: item.value,
          tempUrl: _this2.mediaUrl + '/' + item.value,
          isCover: false,
          order: _this2.vehicle.mediaItems.length + 1
        });
      });
    }
  }, {
    key: 'makeCover',
    value: function makeCover(img) {
      var coverImg = (0, _lodash.find)(this.vehicle.mediaItems, function (o) {
        return o.isCover;
      });
      coverImg.isCover = false;

      var newCoverImg = (0, _lodash.find)(this.vehicle.mediaItems, function (o) {
        return o.url === img.url;
      });
      newCoverImg.isCover = true;
    }
  }, {
    key: 'showRemoveMedia',
    value: function showRemoveMedia(mediaItem) {
      var _this3 = this;

      this.$ngConfirm({
        title: "Warning",
        content: 'Are you sure you want to remove this item ?',
        type: 'orange',
        buttons: {
          renew: {
            text: 'Yes',
            btnClass: 'btn-primary',
            action: function action() {
              _this3.removeMedia(mediaItem);
            }
          },
          cancel: {
            text: 'Leave it',
            btnClass: 'btn-default',
            action: function action() {}
          }
        }
      });
    }
  }, {
    key: 'removeMedia',
    value: function removeMedia(mediaItem) {
      this.vehicle.mediaItems = (0, _lodash.without)(this.vehicle.mediaItems, mediaItem);

      this.vehicle.mediaItems.map(function (val, ind) {
        val.order = ind + 1;
      });

      if (mediaItem.mediaType === this.enums.MEDIA_TYPE.Youtube) {
        this.video = null;
      }
    }
  }, {
    key: 'addExternalImage',
    value: function addExternalImage() {
      var url = prompt("Please enter the URL for the Image");

      var isCover = (0, _lodash.find)(this.vehicle.mediaItems, function (o) {
        return o.isCover;
      });

      if (url) {
        this.vehicle.mediaItems.push({
          mediaType: this.enums.MEDIA_TYPE.ExternalImage,
          url: url,
          isCover: !isCover
        });
      }
    }
  }, {
    key: 'addYoutube',
    value: function addYoutube() {
      var _this4 = this;

      var url = prompt("Please enter the URL for the Youtube Video");

      if (url) {
        var youtubeId = this.getYoutubeId(url);

        if (!youtubeId) {
          this.$ngConfirm({
            title: "Error !",
            content: 'The URL provided is not a valid <br /> <b>Youtube Link: </b> ' + url,
            type: 'red',
            buttons: {
              renew: {
                text: 'Ok',
                btnClass: 'btn-default'
              }
            }
          });

          return;
        }

        this.vehicle.mediaItems.push({
          mediaType: this.enums.MEDIA_TYPE.Youtube,
          url: youtubeId
        });

        this.video = (0, _lodash.find)(this.vehicle.mediaItems, function (mi) {
          return mi.mediaType === _this4.enums.MEDIA_TYPE.Youtube;
        });
      }
    }
  }, {
    key: 'listToMatrix',
    value: function listToMatrix(list, elementsPerSubArray) {
      var matrix = [],
          i,
          k;

      for (i = 0, k = -1; i < list.length; i++) {
        if (i % elementsPerSubArray === 0) {
          k++;
          matrix[k] = [];
        }

        matrix[k].push(list[i]);
      }

      return matrix;
    }
  }, {
    key: 'dragEndHandler',
    value: function dragEndHandler() {
      this.updateOrderNo();
    }
  }, {
    key: 'updateOrderNo',
    value: function updateOrderNo() {
      $('.order-no').each(function (ind, el) {
        $(el).text('#' + (ind + 1));
      });
    }
  }, {
    key: 'getYoutubeId',
    value: function getYoutubeId(url) {
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      var match = url.match(regExp);
      return match && match[7].length == 11 ? match[7] : false;
    }
  }, {
    key: 'hasImages',
    value: function hasImages() {
      var _this5 = this;

      return this.vehicle.mediaItems && (0, _lodash.find)(this.vehicle.mediaItems, function (mi) {
        return mi.mediaType === _this5.enums.MEDIA_TYPE.Image;
      }) != null;
    }
  }, {
    key: 'initializeBrandingTemplates',
    value: function initializeBrandingTemplates() {
      var _this6 = this;

      this.brandingService.list(this.authService.authData.currentLocation.key).then(function (response) {
        var firstItem = { brandingTemplateId: null, name: 'Select Template' };
        _this6.brandingTemplates = [firstItem].concat((0, _toConsumableArray3.default)(response.data));
      });
    }
  }, {
    key: 'showBranding',
    value: function showBranding() {
      var _this7 = this;

      var images = (0, _lodash.filter)(this.vehicle.mediaItems, function (mi) {
        return mi.mediaType === _this7.enums.MEDIA_TYPE.Image;
      }).map(function (val) {
        return {
          originalUrl: val.url.search(/amazon/) === -1 ? val.tempUrl : val.url,
          url: val.url.search(/amazon/) === -1 ? val.tempUrl : val.url,
          selected: false,
          loading: false
        };
      });

      this.$scope.images = images;
      this.$scope.selectedImage = images[0];

      this.$scope.templates = this.brandingTemplates;

      this.$scope.selectedTemplateId = null;

      var updateImage = function updateImage(img) {
        _this7.$scope.selectedImage = img;
      };

      this.$scope.updateImage = updateImage.bind(this);

      this.brandingModal = this.$ngConfirm({
        title: "Image Branding",
        contentUrl: 'templates/vehicle/vehicleBrandingTemplate',
        type: 'black',
        columnClass: 'xl',
        scope: this.$scope,
        buttons: {
          applySelected: {
            text: 'Apply to Selected',
            btnClass: 'btn-dark',
            action: function action() {
              var selectedImages = (0, _lodash.filter)(_this7.$scope.images, function (img) {
                return img.selected;
              });

              if (!selectedImages || !selectedImages.length) {
                alert('Please select images first');
                return false;
              }

              if (!_this7.$scope.selectedTemplateId) {
                alert('Please select a template first');
                return false;
              }

              _this7.applyBranding((0, _lodash.filter)(_this7.$scope.images, function (img) {
                return img.selected;
              }));
              return false;
            }
          },
          applyAll: {
            text: 'Apply to All',
            btnClass: 'btn-dark',
            action: function action() {
              if (!_this7.$scope.selectedTemplateId) {
                alert('Please select a template first');
                return false;
              }

              _this7.$scope.images.map(function (img) {
                return img.selected = true;
              });
              _this7.applyBranding((0, _lodash.filter)(_this7.$scope.images, function (img) {
                return img.selected;
              }));

              return false;
            }
          },
          save: {
            text: 'Save Changes',
            btnClass: 'btn-success',
            action: function action() {
              return _this7.updateImageBranding();
            }
          },
          cancel: {
            text: 'Cancel',
            btnClass: 'btn-default',
            action: function action() {}
          }
        }
      });
    }
  }, {
    key: 'applyBranding',
    value: function applyBranding(selectedImages) {
      var _this8 = this;

      (0, _lodash.map)(this.brandingModal.buttons, function (btn) {
        return btn.setDisabled(true);
      });
      (0, _lodash.map)(selectedImages, function (img) {
        return img.loading = true;
      });

      this.brandingService.applyBranding(this.authService.authData.currentLocation.key, this.$scope.selectedTemplateId, selectedImages).then(function (response) {
        response.data.map(function (img) {
          var matching = (0, _lodash.find)(_this8.$scope.images, function (o) {
            return o.originalUrl === img.originalUrl;
          });
          matching.url = _this8.mediaUrl + '/' + img.url;
        });
      }).finally(function () {
        _this8.brandingApplied = true;

        (0, _lodash.map)(_this8.brandingModal.buttons, function (btn) {
          return btn.setDisabled(false);
        });
        (0, _lodash.map)(selectedImages, function (img) {
          return img.loading = false;
        });
      });
    }
  }, {
    key: 'updateImageBranding',
    value: function updateImageBranding() {
      var _this9 = this;

      this.$scope.images.map(function (img) {
        if (img.originalUrl !== img.url) {
          var mi = (0, _lodash.find)(_this9.vehicle.mediaItems, function (mi) {
            return mi.url === img.originalUrl || mi.tempUrl === img.originalUrl;
          });
          mi.mediaId = 0;
          mi.url = img.url.substring(img.url.lastIndexOf('/') + 1);
          mi.tempUrl = img.url;

          _this9.brandingSaved = true;
        }
      });
    }
  }, {
    key: 'isImage',
    value: function isImage(mediaItem) {
      return mediaItem.mediaType === 1 || mediaItem.mediaType === 3;
    }
  }]);
  return VehicleImagesController;
}();

exports.default = VehicleImagesController;


// WEBPACK FOOTER //
// ./client/app/components/vehicle/vehicleEdit/vehicleImages/vehicleImages.controller.js